import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import { selectores, createSelectorRx } from "app/main/std";

type Entity = models.PaquetePPFiltro;
interface Props {
    value: Entity;
    onChange: (x: Entity) => void;
    idClienteOrigen?: number;
}

export class PaquetePPFiltroView extends React.PureComponent<Props> {
    value = (x: Props) => x.value;
    getField = kea.formfields(() => this.props);
    idClienteOrigen = (x: Props) => x.idClienteOrigen;
    filtroClienteOrigen = createSelectorRx(this.idClienteOrigen, idClienteOrigen => ({ IdRegistro: idClienteOrigen } as models.FiltroCliente))

    render() {
        const value = this.value(this.props);
        const Cliente = this.getField(selectores.Cliente);
        const Tarifa = this.getField(selectores.TarifaPP);
        const Date = this.getField(kea.DateTime);
        const Text = this.getField(kea.Text);

        const filtroClienteOrigen = this.filtroClienteOrigen(this.props);
        const idClienteOrigen = this.idClienteOrigen(this.props);
        return (
            <div>
                {kea.autogrid(4, [
                    <Cliente field="IdCliente" value={idClienteOrigen || value.IdCliente} label="Cliente" filtro={filtroClienteOrigen} />,
                    <Cliente field="IdClienteOrigen" value={idClienteOrigen || value.IdClienteOrigen} label="Cliente orig." filtro={filtroClienteOrigen} />,
                    <Cliente field="IdClienteDestino" label="Cliente dest." />,
                    <Tarifa field="IdTarifaPP" label="Tarifa PP" />,
                    <Date field="FechaCreacionMin" label="Fecha crea (ini)" />,
                    <Date field="FechaCreacionMax" label="Fecha crea (fin)" />,
                    <Text field="FolioGuia" label="Folio guías" />
                ])}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/paquetespp/list/filtro.tsx